import flatpickr from "flatpickr";
import React, { useEffect, useRef, useState } from "react";
import { addQueryLocalStorage, getAllQueryLocalStorage, removeQueryLocalStorage } from "../../../lib/utils";

const PaymentsFilter = () => {

  const dueDateRef = useRef(null);
  const invoiceDateRef = useRef(null);

  const [currentElementId, setCurrentElementId] = useState(null);
  const [dueDate, setDueDate] = useState("");
  const [isDueDateRange, setDueDateRange] = useState(false);
  const [invoiceDate, setInvoiceDate] = useState("");
  const [isInvoiceDateRange, setInvoiceDateRange] = useState(false);
  const [discount, setDiscount] = useState(false);
  

  const toggleInputFields = (id) => event => {
    setCurrentElementId(id);
    if (event) {
      let interval = setInterval(() => {
        let element = event.target.querySelector('input');
        if (element) {
          element.focus();
          clearInterval(interval)
        }
      }, 0);
    }

    if (id === "invoice-date") {
      if (isInvoiceDateRange) {
        const picker = flatpickr(invoiceDateRef.current, {
          mode: "range",
          disableMobile: true,
          dateFormat: "Y-m-d",
          onChange: (selectedDates) => {
            if (selectedDates.length === 2) {
              const [start, end] = selectedDates;

              const startIST = start.toLocaleDateString('en-CA', {
                timeZone: 'Asia/Kolkata'
              });

              const endIST = end.toLocaleDateString('en-CA', {
                timeZone: 'Asia/Kolkata'
              });

              setInvoiceDate(`${startIST} to ${endIST}`);

              addQueryLocalStorage("invoice_date_start",start);
              addQueryLocalStorage("invoice_date_end",end);

              picker.close();
            }
          }
        });
      } else {
        const picker = flatpickr(invoiceDateRef.current, {
          enableTime: true,
          disableMobile: true,
          dateFormat: "Y-m-d",
          onChange: ([date]) => {
            if (date) {
              const istDate = date.toLocaleDateString('en-CA', {
                timeZone: 'Asia/Kolkata'
              });

              setInvoiceDate(istDate);
              addQueryLocalStorage("invoice_date",date);

            }

            picker.close();
          }
        });
      }
    }

    if (id === "due-date") {
      if (isDueDateRange) {
        const picker = flatpickr(dueDateRef.current, {
          mode: "range",
          disableMobile: true,
          dateFormat: "Y-m-d",
          onChange: (selectedDates) => {
            if (selectedDates.length === 2) {
              const [start, end] = selectedDates;

              const startIST = start.toLocaleDateString('en-CA', {
                timeZone: 'Asia/Kolkata'
              });

              const endIST = end.toLocaleDateString('en-CA', {
                timeZone: 'Asia/Kolkata'
              });

              setDueDate(`${startIST} to ${endIST}`);

              addQueryLocalStorage("due_date_start",start);
              addQueryLocalStorage("due_date_end",end);

              picker.close();
            }
          }
        });
      }else{
        const picker = flatpickr(dueDateRef.current, {
          enableTime: true,
          disableMobile: true,
          dateFormat: "Y-m-d",
          onChange: ([date]) => {
            if (date) {
              const istDate = date.toLocaleDateString('en-CA', {
                timeZone: 'Asia/Kolkata'
              });

              addQueryLocalStorage("due_date",date);

              setDueDate(istDate);

              picker.close();
            }
          }
        });
      }
    }

  }

  const toggleInvoiceDateRange = () => {
    removeQueryLocalStorage("invoice_date_start");
    addQueryLocalStorage("invoice_date_end");
    addQueryLocalStorage("invoice_date");
    setInvoiceDateRange(!isInvoiceDateRange);
    setInvoiceDate("");
  }

  const toggleDueDateRange = () => {
    addQueryLocalStorage("due_date_start");
    addQueryLocalStorage("due_date_end");
    addQueryLocalStorage("due_date");
    setDueDateRange(!isDueDateRange);
    setDueDate("");
  }

  const toggleDiscount = () => {
    setDiscount(!discount);
    if(!discount){
      addQueryLocalStorage("discount",!discount);
    }else{
      addQueryLocalStorage("discount");
    }
  }



  useEffect(()=>{
    const queries = getAllQueryLocalStorage();
    if(( !isDueDateRange && !queries.due_date) || (isDueDateRange && (!queries.due_date_start || !queries.due_date_end))){
      if(`${dueDate}`.includes("to")) setDueDateRange(false)
      setDueDate("")
    }

    if((!isInvoiceDateRange && !queries.invoice_date) || (isInvoiceDateRange && (!queries.invoice_date_start || !queries.invoice_date_end))){
      if(`${invoiceDate}`.includes("to")) setInvoiceDateRange(false);
      setInvoiceDate("")
    }

    if(discount && !queries.discount) setDiscount(false)

  },[getAllQueryLocalStorage()]);


  return(
    <div className="w-full">
      <p className="fs-16 m-b-6 font-weight-700 color-black">Due Date</p>
      <div className="d-flex space-between">
        <div onClick={toggleInputFields('due-date')} className={`${(currentElementId == 'due-date' || dueDate) ? "member-global-input-field" : "member-global-input-field d-flex"}`} style={{ border: (currentElementId == 'due-date' || dueDate) ? "1px solid var(--darkBlue)" : "", width: "74%" }}>
          <div className="flex-item d-flex">
            <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'due-date' || dueDate) ? "10px" : "14px", color: (currentElementId == 'due-date' || dueDate) ? "#4d4d4d" : "", transition: "180ms" }}>{isDueDateRange ? "Date Range" : "Date"}</p>
          </div>
          <input ref={dueDateRef} value={dueDate} readOnly style={{color: "#2b2b2b", pointerEvents:"none"}} className={`${(currentElementId == 'due-date' || dueDate) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder={isDueDateRange ? 'YYYY-MM-DD to YYYY-MM-DD' : 'YYYY-MM-DD'} />
        </div>
        <div style={{alignSelf:"flex-start", marginTop:"-3px"}}>
          <p className="fs-14 color-dark-blue font-weight-700 m-b-6">Date Range</p>
          <div onClick={()=>toggleDueDateRange()} className='toggle-button d-flex cursor-pointer' style={{backgroundColor: isDueDateRange && "#B3E28F"}}>
            <div className='toggle-ball flex-item' style={{margin: isDueDateRange ? "-2px 0 0 30px" : "-2px 0 0 -2px",  backgroundColor: isDueDateRange && "#5d883c"}} />
          </div>
        </div>
      </div>
      <p className="fs-16 m-t-20 m-b-6 font-weight-700 color-black">Invoice Date</p>
      <div className="d-flex space-between">
        <div onClick={toggleInputFields('invoice-date')} className={`${(currentElementId == 'invoice-date' || invoiceDate) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'invoice-date' || invoiceDate) ? "1px solid var(--darkBlue)" : "", width: "74%" }}>
          <div className="flex-item d-flex">
            <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'invoice-date' || invoiceDate) ? "10px" : "14px", color: (currentElementId == 'invoice-date' || invoiceDate) ? "#4d4d4d" : "", transition: "180ms" }}>{isInvoiceDateRange ? "Date Range" : "Date"}</p>
          </div>
          <input ref={invoiceDateRef} value={invoiceDate} readOnly style={{color: "#2b2b2b", pointerEvents:"none"}} className={`${(currentElementId == 'invoice-date' || invoiceDate) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='YYYY-MM-DD' />
        </div>
        <div style={{alignSelf:"flex-start", marginTop:"-3px"}}>
          <p className="fs-14 color-dark-blue font-weight-700 m-b-6">Date Range</p>
          <div onClick={()=>toggleInvoiceDateRange()} className='toggle-button d-flex cursor-pointer' style={{backgroundColor: isInvoiceDateRange && "#B3E28F"}}>
            <div className='toggle-ball flex-item' style={{margin: isInvoiceDateRange ? "-2px 0 0 30px" : "-2px 0 0 -2px",  backgroundColor: isInvoiceDateRange && "#5d883c"}} />
          </div>
        </div>
      </div>
      <div onClick={() => toggleDiscount()} className="d-flex m-t-20">
        {
          discount ? (
            <svg className="flex-item m-r-12" width="22" height="22" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="19" height="19" rx="5" fill="#0088DA"/>
              <path d="M5 10.0526L7.86364 13L14 6" stroke="white" stroke-width="2" stroke-linecap="round"/>
            </svg>
          ) : (
            <svg className="flex-item m-r-12" width="22" height="22" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="18" height="18" rx="3.5" fill="#EDEDED" stroke="#BFBFBF"/>
            </svg>
          )
        }
        <p className="fs-16 flex-item font-weight-700 color-black">Discount</p>
      </div>
    </div>
  )
}

export default PaymentsFilter;